import { colors, radii, typography as typographyTokens } from '@components/design-system/tokens';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        padding: 20,
        backgroundColor: colors.neutral[0],
        borderRadius: `${radii.lg}px`,
        border: `1px solid ${colors.neutral[200]}`,
        boxShadow: 'none',
        [theme.breakpoints.down('md')]: {
            padding: 16,
        },
    },
    wrapper: {
        height: '100%',
    },
    header: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',

        [theme.breakpoints.down('lg')]: {
            marginBottom: theme.spacing(1),
        },
    },
    description: {
        marginBottom: theme.spacing(1.5),
        color: colors.neutral[600],
        fontSize: typographyTokens.fontSize.sm,
    },
    reportTitle: {
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            alignItems: 'center',
        },
    },
    reportDate: {
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            alignItems: 'center',
        },
    },
    filter: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,

        [theme.breakpoints.up('sm')]: {
            flexBasis: 'auto',
            marginTop: 0,
        },
        '& .MuiOutlinedInput-root': {
            height: '36px',
            borderRadius: `${radii.md}px`,
        },
        '& .MuiToggleButtonGroup-root': {},
        '& .MuiToggleButtonGroup-grouped': {
            height: 36,
            padding: 0,
        },
        '& .MuiSelect-select:focus': {
            backgroundColor: colors.neutral[0],
            outline: 0,
        },
        '& .MuiOutlinedInput-input': {
            padding: '8px 14px',
            width: '70px',
        },
    },
    actions: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        justifyContent: 'flex-end',
        alignContent: 'center',
        flexWrap: 'wrap',
        gap: 8,
        [theme.breakpoints.down('md')]: {
            justifyContent: 'flex-start',
        },
    },
    title: {
        marginBottom: theme.spacing(1),
        flexGrow: 2,
        maxWidth: '100%',

        '& > :first-child': {
            paddingRight: theme.spacing(1.5),
        },
    },
    titleText: {
        fontSize: typographyTokens.fontSize.lg,
        fontWeight: typographyTokens.fontWeight.semibold,
        color: colors.neutral[900],
        overflow: 'hidden',
    },
    dateText: {
        fontSize: typographyTokens.fontSize.sm,
        color: colors.neutral[500],
    },
    toggleButton: {
        '& .MuiToggleButton-root.Mui-selected': {
            backgroundColor: colors.primary[500],
            color: colors.neutral[0],
        },
        maxHeight: '36px',
    },
    toggleIcon: {
        padding: 10,
        paddingTop: 14,
    },
    rangeSelect: {
        '& .MuiOutlinedInput-input': {
            width: '100px',
            padding: '8px 14px',
        },
    },
    reloadLink: {
        textTransform: 'lowercase',
        fontStyle: 'italic',
        fontSize: typographyTokens.fontSize.base,
        margin: '0px 5px',
        cursor: 'pointer',
        color: colors.primary[600],
    },
}));
